import { Injectable } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

/** Set on HttpClient requests that should not trigger the global spinner overlay. */
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  public host = environment.apiUrlHost;

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private isLocked = false; // Lock to prevent hiding during critical operations

  /** In-flight HTTP requests tracked by SpinnerInterceptor (when not locked). */
  private httpSpinnerRefCount = 0;

  constructor(private http: HttpClient) { }

  /** True while spinner is locked (e.g. multi-step reorder); interceptor must not toggle loading. */
  get isSpinnerLocked(): boolean {
    return this.isLocked;
  }

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    // Only hide if not locked
    if (!this.isLocked) {
      this.loadingSubject.next(false);
    }
  }

  /**
   * SpinnerInterceptor: one show for the first concurrent HTTP request, hide only when all complete.
   */
  httpRequestStarted(): void {
    if (this.isLocked) {
      return;
    }
    this.httpSpinnerRefCount++;
    if (this.httpSpinnerRefCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  httpRequestEnded(): void {
    if (this.isLocked) {
      return;
    }
    this.httpSpinnerRefCount = Math.max(0, this.httpSpinnerRefCount - 1);
    if (this.httpSpinnerRefCount === 0) {
      this.hide();
    }
  }

  /**
   * Lock the spinner to prevent it from being hidden
   * Useful for multi-step operations like checkout
   */
  lock() {
    this.isLocked = true;
  }

  /**
   * Unlock the spinner, allowing it to be hidden again
   */
  unlock() {
    this.isLocked = false;
  }

  /**
   * Force hide the spinner even if locked
   * Use with caution - only when you're sure the operation is complete
   */
  forceHide() {
    this.isLocked = false;
    this.httpSpinnerRefCount = 0;
    this.loadingSubject.next(false);
  }

  public getImages(): Observable<any> {
    // query parameter
    return this.http.get(`${this.host}/AD/loader/`)
  }
  public getText(): Observable<any> {
    // query parameter
    return this.http.get(`${this.host}/AD/loaderText/`)
  }
}
